import { render, staticRenderFns } from "./GroupTabMarketPlace.vue?vue&type=template&id=79686487&scoped=true&"
import script from "./GroupTabMarketPlace.vue?vue&type=script&lang=js&"
export * from "./GroupTabMarketPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79686487",
  null
  
)

export default component.exports